<template>
  <el-tooltip v-if="row[config.prop] || row[config.prop] === 0">
    <template #content>
      <div class="common-table-tooltip">{{ getText }}</div>
    </template>
    <div class="text-overflow-2">
      {{ getText }}
    </div>
  </el-tooltip>
  <div v-else>{{ emptyCell }}</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "table-tooltip",
  props: {
    row: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    emptyCell: {
      type: String,
      default: "--"
    }
  },
  computed: {
    getText() {
      const value = this.row[this.config.prop] ?? this.emptyCell;
      if (Array.isArray(value)) {
        return value.join("");
      } else {
        return value;
      }
    }
  }
});
</script>
<style scoped>
.text-overflow-in-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

.common-table-tooltip {
  max-width: 25vw;
}
</style>
